import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
export var separator = /*#__PURE__*/css("margin-left:16px;margin-right:16px;height:16px;vertical-align:middle;display:inline-block;padding:0;border-right:1px solid ", variables.colour.neutral300, ";");
export default null;